import { render, staticRenderFns } from "./alpha-bar.vue?vue&type=template&id=66a5f67d&"
import script from "./alpha-bar.vue?vue&type=script&lang=js&"
export * from "./alpha-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports